export default __webpack_public_path__ + "static/media/coin.607f3cfb.wav";